<script>
import Cookies from 'js-cookie'
import { mapActions } from 'vuex'
import { serverTimeFunc } from '@/utils/serverTime'

export default {
  name: 'TokenMixin',
  methods: {
    ...mapActions(['showAlert']),
    getCurrentUserData() {
      const data = Cookies.get(process.env.VUE_APP_COOKIE_NAME)

      if (data !== undefined && data !== null && data !== '') {
        return JSON.parse(Cookies.get(process.env.VUE_APP_COOKIE_NAME))
      }

      return {}
    },
    /**
     * @param {Object} data - { id: -1, user_type: '', username: '', centers: [], selected_center: -1, last_login: new Date().getTime() }
     */
    setUserData(data) {
      const userData = this.getCurrentUserData()
      if (this.$validate.DataValid(userData)) {
        Cookies.remove(process.env.VUE_APP_COOKIE_NAME)
      }

      const expired = serverTimeFunc.getLocalCurrentDateObj()
      expired.setMonth(expired.getMonth() + 1, 1) // expires after 1 month

      Cookies.set(process.env.VUE_APP_COOKIE_NAME, JSON.stringify(data), {
        path: '/',
        expires: expired,
        sameSite: 'strict',
        secure: true,
      })
    },

    getUserType() {
      // 'developer' | 'manager' | 'admin' | 'tutor' | 'beautician' | 'consultant' | 'front' | 'accountant' | 'student'
      const userData = this.getCurrentUserData()
      return userData.user_type
    },
    getUserSelectedCenter() {
      const userData = this.getCurrentUserData()
      if (
        this.$validate.DataValid(userData.centers) &&
        this.$validate.DataValid(userData.selected_center) &&
        userData.centers.includes(userData.selected_center)
      ) {
        return userData.selected_center
      }

      return null
    },
    async updateUserCenters(centers) {
      const check = this.checkUserData()
      if (check) {
        const userData = this.getCurrentUserData()
        const newData = {
          ...userData,
          centers: centers,
        }
        await this.setUserData(newData)
        return true
      }

      return false
    },
    async updateUserSelectedCenter(selectedCenter) {
      const check = this.checkUserData()
      if (check) {
        const userData = this.getCurrentUserData()
        const newData = {
          ...userData,
          selected_center: selectedCenter,
        }
        await this.setUserData(newData)
        return true
      }

      return false
    },
    removeUserCookies() {
      const userData = this.getCurrentUserData()
      if (this.$validate.DataValid(userData)) {
        Cookies.remove(process.env.VUE_APP_COOKIE_NAME)
      }
    },
    checkUserData() {
      let resultType = false
      const userData = this.getCurrentUserData()

      if (this.$validate.DataValid(userData)) {
        if (
          this.$validate.DataValid(userData.id) &&
          this.$validate.DataValid(userData.username) &&
          this.$validate.DataValid(userData.user_type)
        ) {
          resultType = true
        }
      }

      if (!resultType) {
        this.forceLogout()
      } else {
        const linkName = this.$route.name
        if (linkName && !this.$validate.allowAction(linkName, userData.user_type)) {
          resultType = false
          this.showAlert({
            message: 'noPermission',
            userType: userData.user_type,
          })
          this.$store.dispatch('toggleLoadingPage', false)
        }
      }

      return resultType
    },
    async logout() {
      let redirect = { name: 'login' }
      const userData = this.getCurrentUserData()
      if (userData && userData.user_type === 'student') {
        redirect = { name: 'CustomerLogin', params: { username: userData.username } }
      }
      await this.removeUserCookies()
      this.$router.replace(redirect)
    },
    async forceLogout() {
      this.$store.dispatch('toggleLoadingPage', true)
      await this.removeUserCookies()

      this.$store.dispatch('toggleSnack', {
        message: 'message.loginExpired',
        type: 'error',
        redirect: 'login',
      })
    },
  },
}
</script>
